import { render } from "./FaqsSection.vue?vue&type=template&id=13fa6804&scoped=true&bindings={\"showHeader\":\"props\",\"faqsData\":\"data\"}"
import script from "./FaqsSection.vue?vue&type=script&lang=js"
export * from "./FaqsSection.vue?vue&type=script&lang=js"

import "./FaqsSection.vue?vue&type=style&index=0&id=13fa6804&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-13fa6804"

export default script